import {KMDFSOutro} from "./KMDFSOutro";
import {KennethMustDie} from "../../KennethMustDie";
import {KMDSound} from "../../sound/KMDSound";

export class KMDSFSOutro extends KMDFSOutro {

    constructor() {
        super();
        this.name = "KMDSFSOutro";
    }

    protected getAssetName(): string {
        return ("sfsOutro");
    }

    protected getAnimationTabName(isBelowWinStake: boolean, totalWin: number, playedBetValue: number): string {
        let retVal: string = "animation",
            ratio: number = (totalWin / playedBetValue);

        if (isBelowWinStake) {
            return retVal;
        }

        if (ratio >= 25 && ratio < 50) {
            retVal += 2;
        } else if (ratio >= 50 && ratio < 100) {
            retVal += 3;
        } else if (ratio >= 100 && ratio < 500) {
            retVal += 4;
        } else if (ratio >= 500) {
            retVal += 5;
        }

        return retVal;
    }

    // #479
    protected playOutroSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.SFS_OUTRO_IMPACT);

        KennethMustDie.soundPlayer.switchMusic("loaderLoop");
    }

    protected playBtnSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.BTN_OUTRO_SFS);
    }
}